module.exports = __webpack_public_path__ + "de77a722/img/rename-icon.de4e673d.svg";